module.exports = __webpack_public_path__ + "img/ron_d_2.668a7ed6.png";